import { render, staticRenderFns } from "./ResumeAddress.vue?vue&type=template&id=0cc6e89b"
import script from "./ResumeAddress.vue?vue&type=script&lang=ts"
export * from "./ResumeAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports